/* eslint-disable no-empty-function */
/* eslint-disable linebreak-style */
// Copyright (c) 2025 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import Attachments from '../../../shared/components/attachments';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import {Link} from 'react-router';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import SecureFooter from '../../../shared/components/secure-footer';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';

const buildUseAmount = useAmount => `${useAmount.amount} ${useAmount.unit.value}`;

class AmountOfUseResult extends Component {

    constructor() {

        super();
        this.handleApproval = this.handleApproval.bind(this);
        this.handleDenial = this.handleDenial.bind(this);

    }
    handleApproval() {

        this.props.openUpdateStatusChangeModal(this.props.amountOfUse, 'APPROVE');

    }

    handleDenial() {

        this.props.openUpdateStatusChangeModal(this.props.amountOfUse, 'DENY');

    }

    render() {

        return (
            <section className='spa-result'>
                <header>
                    <section className='spa-title'>
                        <span>
                            <Link
                                className='product-title'
                                rel='noopener noreferrer'
                                target='_blank'
                                to={`/products/${this.props.amountOfUse.pin}`}
                            >
                                <FormattedMessage
                                    id={this.props.amountOfUse.pin}
                                ></FormattedMessage>
                            </Link>
                        </span>

                    </section>
                </header>
                <div className='spa-details'>
                    <div className='row'>
                        <LabeledString
                            className='responsible-account lost-two-column'
                            data={buildDealer(this.props.amountOfUse.tcsmData.dealer)}
                            label='DEALER_LOCATION'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='responsible-account lost-two-column'
                            data={this.props.amountOfUse.tcsmData.customerSummary.displayName}
                            label='CUSTOMER'

                        />
                        <LabeledString
                            className='created-on'
                            data={this.props.amountOfUse.tcsmData.model}
                            label='MODEL'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='responsible-account lost-two-column'
                            data={this.props.amountOfUse.tcsmData.createdBy.buildUserName()}
                            label='CREATED_BY'
                        />
                        <LabeledString
                            className='created-on'
                            data={buildDate(this.props.amountOfUse.tcsmData.createdOn)}
                            label='CREATED_ON'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='responsible-account lost-two-column'
                            data={buildUseAmount(this.props.amountOfUse.useAmount)}
                            label='ACTUAL_AMOUNT_OF_USE'
                        />
                        <LabeledString
                            className='created-on'
                            data={buildDate(this.props.amountOfUse.date)}
                            label='READING_DATE'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='dealer-comments'
                            data={this.props.amountOfUse.dealerComments}
                            label='DEALER_COMMENTS'
                        />
                    </div>
                    <div className='row'>
                        <Attachments files={this.props.amountOfUse.file}/>
                    </div>

                    <SecureFooter
                        onApprove={this.handleApproval}
                        onDeny={this.handleDenial}
                        securityFeature='TCSM_MACHINE_STATUS_PROCESS'
                        securityModule='TCSM'
                    />

                </div>
            </section>
        );

    }
    }

AmountOfUseResult.displayName = 'AmountOfUseResult';
AmountOfUseResult.propTypes = {
    actions: PropTypes.object.isRequired,
    amountOfUse: PropTypes.instanceOf(MeasurementReading).isRequired,
    openUpdateStatusChangeModal: PropTypes.func.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String))
};

export default AmountOfUseResult;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/update-amount-of-use/update-amount-of-use-results.js